
import React, { useEffect, useRef, useState, useContext } from "react";
// import { Cloudinary } from "cloudinary-react";
import axios from 'axios'



import EnvRoute from '../middleware/envRoute';
const ENDPOINT = EnvRoute('prod'); 

/*--------------------
------Meeting Calls-------
----------------------*/

/*----------Fetch------------*/
export const fetchUserMeetings = async(obj) =>{
    try{
          const config = {
           headers: {
           "Content-type": "application/json",
             Authorization: `Bearer ${obj?.token}`,
           },
       };
       const { data } = await axios.post(
           `${ENDPOINT[0]}/meeting/all`,
          {_id: obj?._id},
           config
       );
    //    console.log("APICalls scans: ",data)
        return data

    }catch(err){console.log(err)}

}